import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import remarkMath from 'remark-math'
import remarkGemoji from 'remark-gemoji'
import rehypeKatex from 'rehype-katex'
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter'
import {vscDarkPlus} from 'react-syntax-highlighter/dist/esm/styles/prism'
import Card from '@mui/material/Card'
import Box from '@mui/material/Box'
import style from './markdown-styles.module.css'

export default function MarkdownDisplay(props: { value: string }) {
  return (
    <>
      <Box >
        <ReactMarkdown
          children={props.value}
          className={style.reactMarkDown}
          remarkPlugins={[remarkGfm, remarkMath, remarkGemoji]}
          rehypePlugins={[rehypeKatex]}
          components={{
            code({node, inline, className, children, ...props}) {
              const match = /language-(\w+)/.exec(className || '')
              return !inline && match ? (
                <SyntaxHighlighter
                  children={String(children).replace(/\n$/, '')}
                  // @ts-ignore
                  style={vscDarkPlus}
                  language={match[1]}
                  PreTag="div"
                  {...props}
                />
              ) : (
                <code className={className} {...props}>
                  {children}
                </code>
              )
            }
          }}
          disallowedElements={['img']}
        />
      </Box>
    </>
  )
}
